import { createApp } from 'vue';
import Main from '@/Main.vue';
import router from "@/router/router";
import store from '@/store/store';
import conf from '/src/config';
import moment from 'moment-timezone';
import fnc from "@/fnc";
import Loader from "@/components/Loader";
import wait from "@meforma/vue-wait-for";
import WaitComp from '@/components/Wait';

import PrimeVue from 'primevue/config';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import ToggleButton from 'primevue/togglebutton';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import OverlayPanel from 'primevue/overlaypanel';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';

import Ripple from 'primevue/ripple';
import Tooltip from 'primevue/tooltip';

moment.locale('tr');

const app = createApp(Main);
app.use(wait);
app.use(router);
app.use(store);
app.use(PrimeVue, {ripple: true});
app.use(ToastService);
app.use(ConfirmationService);

app.component("InputText",InputText);
app.component("InputMask",InputMask);
app.component("InputNumber",InputNumber);
app.component("Textarea",Textarea);
app.component("Button",Button);
app.component("ToggleButton",ToggleButton);
app.component('Checkbox',Checkbox);
app.component('RadioButton',RadioButton);
app.component("Dropdown",Dropdown);
app.component("MultiSelect",MultiSelect);
app.component("DataTable",DataTable);
app.component("Column",Column);
app.component("Dialog",Dialog);
app.component('OverlayPanel',OverlayPanel);
app.component("ConfirmDialog",ConfirmDialog);
app.component("Toast",Toast);

app.component('Loader',Loader);
app.component("Wait",WaitComp);

app.directive('ripple', Ripple);
app.directive('tooltip', Tooltip);

app.config.globalProperties.$conf   = conf;
app.config.globalProperties.$fnc    = fnc;
app.config.globalProperties.$moment = moment;

app.directive('upperCase', {
    updated: function (el) {
        const sourceValue = el.value;
        //const newValue = sourceValue.toUpperCase();
        const newValue = sourceValue.toLocaleUpperCase('TR');
        if (sourceValue !== newValue) {
            el.value = newValue;
            el.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }
})

app.mount('#app');


const _vm = app.config.globalProperties;
export default _vm;

import './assets/css/main.css';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './assets/css/primeUiCostom.css';
